import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PaginationControlsDirective, PaginationInstance } from 'ngx-pagination';

@Component({
  selector: 'oir-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginationComponent implements OnInit {
  @Input('options') options: PaginationInstance;
  @Output('pageChange') readonly pageChange: EventEmitter<any> = new EventEmitter();
  @ViewChild('pagDirective', { static: true }) pagDirective: PaginationControlsDirective;

  lastPage: number;

  ngOnInit(): void {
    if (!this.options.id) {
      this.options.id = 'pagination-control';
    }
    this.lastPage = this.getLastPage();
    this.pagDirective.maxSize = 5;
  }

  get shouldEnableLastPage(): boolean {
    return !this.pagDirective.isLastPage() && this.options.totalItems > this.options.itemsPerPage * 2;
  }

  get shouldEnableFirstPage(): boolean {
    return !this.pagDirective.isFirstPage() && this.options.totalItems > this.options.itemsPerPage * 2;
  }

  onPageChange($event): void {
    this.pageChange.emit($event);
  }

  getLastPage(): number {
    const numberOfPages = Math.floor(this.options.totalItems / this.options.itemsPerPage);
    return this.options.totalItems % this.options.itemsPerPage === 0 ? numberOfPages : numberOfPages + 1;
  }

  getPageRange(originalArray): Array<any> {
    this.removeElipsisItem(originalArray);
    this.removeElipsisItem(originalArray); // because there can be 2

    return originalArray;
  }

  private removeElipsisItem(array): void  {
    const elipsisItem = array.find(x => x.label === '...');
    if (!elipsisItem) {
      return array;
    }

    const elipsisItemIndex = array.indexOf(elipsisItem);
    let factor = 1;

    if (elipsisItemIndex === 1) { // previous is the First
      factor = factor * (-1);
    }

    const followItem = array[elipsisItemIndex + factor];
    if (followItem) {
      followItem.value = elipsisItem.value + factor;
    }
    elipsisItem.label = elipsisItem.value;
  }
}
